import { getExclusivePartners } from '../api/eae'

export const exclusivePartnersMixin = {
    data() {
        return {
            exclusivePartners: []
        }
    },
    methods: {
        async fetchExclusivePartners(projectCode) {
            try {
                const res = await getExclusivePartners(projectCode)
                if (res.data.code === 0) {
                    this.exclusivePartners = res.data.data || []
                }
            } catch (err) {
                console.error('Failed to fetch exclusive partners:', err)
            }
        },

        normalizeExclusivePartnerAccountId(accountId) {
            if (!accountId) {
                return ''
            }
            if (typeof accountId === 'object' && accountId.$id) {
                return String(accountId.$id)
            }
            return String(accountId)
        },

        getCurrentExclusivePartnerAccountId(accountId) {
            const candidates = [
                accountId,
                this.form && this.form.account_id,
                this.account_id,
                this.$route && this.$route.query && this.$route.query.account_id
            ]

            for (const candidate of candidates) {
                const normalized = this.normalizeExclusivePartnerAccountId(candidate)
                if (normalized) {
                    return normalized
                }
            }
            return ''
        },

        isCurrentExclusivePartner(partner, accountId) {
            if (!partner || !partner.account_id) {
                return false
            }

            const partnerAccountId = this.normalizeExclusivePartnerAccountId(partner.account_id)
            const currentAccountId = this.getCurrentExclusivePartnerAccountId(accountId)
            return partnerAccountId !== '' && partnerAccountId === currentAccountId
        },

        checkExclusivePartner(country, accountId) {
            const partner = this.exclusivePartners.find(p => p.country === country)
            if (partner && partner.account_info && !this.isCurrentExclusivePartner(partner, accountId)) {
                const message = `Notice: ${partner.account_info.account_name || partner.account_info.account_nameEN} is the exclusive partner in ${country}. You need to contact them directly for registration.\n\nContact: ${partner.account_info.admin_email || 'Please visit their website for contact information.'}`
                this.$alert(message, 'Exclusive Partner Notice', {
                    confirmButtonText: 'OK',
                    type: 'warning'
                })
            }
        },

        validateExclusivePartnerBeforeSubmit(country, accountId) {
            const partner = this.exclusivePartners.find(p => p.country === country)
            if (partner && partner.account_info && !this.isCurrentExclusivePartner(partner, accountId)) {
                const message = `Cannot submit: ${partner.account_info.account_name || partner.account_info.account_nameEN} is the exclusive partner in ${country}. You need to contact them directly for registration.\n\nContact: ${partner.account_info.admin_email || 'Please visit their website for contact information.'}`
                this.$alert(message, 'Submission Blocked', {
                    confirmButtonText: 'OK',
                    type: 'error'
                })
                return false
            }
            return true
        }
    }
}
